import { Controller } from "@hotwired/stimulus"

// Handles expandable media rows in the admin media table
export default class extends Controller {
  static targets = ["details", "icon"]

  connect() {
    // Ensure details start hidden
    if (this.hasDetailsTarget) {
      this.detailsTarget.classList.add("hidden")
    }
  }

  toggle(event) {
    // Don't toggle if clicking on interactive elements
    if (event.target.closest('input, button, a, dialog')) {
      return
    }

    const isExpanded = !this.detailsTarget.classList.contains("hidden")

    if (isExpanded) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    this.detailsTarget.classList.remove("hidden")
    this.element.querySelector('tr[data-row]').classList.add("bg-indigo-50")

    // Rotate icon
    if (this.hasIconTarget) {
      this.iconTarget.style.transform = "rotate(90deg)"
    }
  }

  collapse() {
    this.detailsTarget.classList.add("hidden")
    this.element.querySelector('tr[data-row]').classList.remove("bg-indigo-50")

    // Reset icon rotation
    if (this.hasIconTarget) {
      this.iconTarget.style.transform = "rotate(0deg)"
    }
  }
}
